"use strict";
/**
 * Markets Constants
 * Market categories and configuration
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOVIG_LEAGUE_LABELS = exports.MARKET_CACHE_DURATION = exports.MARKET_CATEGORIES = void 0;
exports.novigLeagueLabel = novigLeagueLabel;
exports.novigCoarseType = novigCoarseType;
exports.novigMarketTypeLabel = novigMarketTypeLabel;
const novig_market_types_1 = require("../../shared/novig-market-types");
// Market categories
exports.MARKET_CATEGORIES = {
    SPORTS: "sports",
    ELECTIONS: "elections",
    EVENTS: "events",
    CRYPTOCURRENCY: "crypto",
};
// Market cache configuration
exports.MARKET_CACHE_DURATION = 300 * 1000; // 5 minutes
/**
 * Display labels for Novig's leagues.
 *
 * Novig returns a bare `["NFL", "NBA", …]` — no labels, no ordering. The emoji
 * mirror the Kalshi league selector so both venues read the same way. An
 * unlisted league falls back to its raw code rather than being hidden: Novig's
 * list is open-ended and a missing entry must not cost the operator a league.
 */
exports.NOVIG_LEAGUE_LABELS = {
    NBA: "🏀 NBA",
    NFL: "🏈 NFL",
    MLB: "⚾ MLB",
    NHL: "🏒 NHL",
    NCAAB: "🏀 NCAA M",
    NCAAF: "🏈 NCAA F",
    MLS: "⚽ MLS",
    EPL: "⚽ EPL",
    UFC: "🥊 UFC",
    PGA: "⛳ PGA",
    WNBA: "🏀 WNBA",
    ATP: "🎾 ATP",
    WTA: "🎾 WTA",
};
/** A Novig league's display label, falling back to the raw code. */
function novigLeagueLabel(league) {
    return exports.NOVIG_LEAGUE_LABELS[league.toUpperCase()] ?? league;
}
/** Labels where title-casing Novig's `marketType` would read badly. */
const NOVIG_MARKET_TYPE_LABELS = {
    MONEY: "Moneyline",
    MONEYLINE_3_WAY_WIN: "3-Way Win",
    MONEYLINE_3_WAY_DRAW: "3-Way Draw",
};
/** A Novig `marketType`'s chip tier (`markets/market-categories.ts`); an unknown type sorts with props. */
function novigCoarseType(marketType) {
    return (0, novig_market_types_1.novigCoarseTier)(marketType) ?? "props";
}
/** A Novig `marketType`'s label: `TEAM_TOTAL` → "Team Total". The list is open-ended. */
function novigMarketTypeLabel(marketType) {
    return (NOVIG_MARKET_TYPE_LABELS[marketType] ??
        marketType
            .toLowerCase()
            .split("_")
            .filter(Boolean)
            .map((word) => word[0].toUpperCase() + word.slice(1))
            .join(" "));
}
